<template>
  <div v-if="isCreated">
    <div v-if="desktopWidth">
      <img 
        src="@/assets/image/topup_header_d_no_diamond.png"
        style="width: 100%;"/>
    </div>
    <div v-if="!desktopWidth">
      <img 
        src="@/assets/image/topup-header_m_no_diamond.png"
        style="width: 100%;"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopupHeaderImage',
  props: {
  },
  data: function() {
    return {
      width: 0,
      isCreated: false
    };
  },
  created: function() {
    window.addEventListener('resize', this.handleWindowResize);
    window.addEventListener('orientationchange', this.handleWindowResize);
    this.handleWindowResize();
    this.isCreated = true;
  },
  destroyed: function() {
    window.removeEventListener('resize', this.handleWindowResize);
    window.removeEventListener('orientationchange', this.handleWindowResize);
  },
  computed: {
    desktopWidth: function() {
      const mobileBreakpoint = 768;
      return this.width > mobileBreakpoint;
    }
  },
  methods: {
    handleWindowResize: function() {
      this.width = document.documentElement.clientWidth;
    },
  }
};
</script>
